(function () {
    "use strict";

    angular
        .module("atheer.content")
        .controller("ContentViewController", ContentViewController);

    /* @ngInject */
    function ContentViewController($scope, $window, $state, $sce, $location, $rootScope, $timeout) {
        var vm = this;
        vm.ngxUrlTrusted = null;
        vm.isIFrameDataLoaded = false;
        var DOCUMENT_NEW_VERSION_TOAST_PENDING_KEY = 'DocumentNewVersionToastPending';
        var DOCUMENT_NEW_VERSION_TOAST_SHOWN_KEY = 'DocumentNewVersionToastShown';
        var pendingToastPushTimeouts = [];

        function getNgxHostUrl() {
            return location.hostname === "localhost"
                ? "https://" + location.hostname + ":4200"
                : location.origin;
        }

        function mergeToastMapFromRaw(pending, raw) {
            if (!raw) {
                return;
            }
            try {
                var parsed = JSON.parse(raw);
                if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
                    Object.keys(parsed).forEach(function (id) {
                        pending[id] = parsed[id];
                    });
                }
            } catch (e) {
                // Ignore parse errors.
            }
        }

        function readStorageToastMap(key) {
            var pending = {};
            try {
                mergeToastMapFromRaw(pending, sessionStorage.getItem(key));
            } catch (e) { /* ignore */ }
            try {
                mergeToastMapFromRaw(pending, localStorage.getItem(key));
            } catch (e) { /* ignore */ }
            try {
                var cookieMatch = document.cookie.match(
                    new RegExp('(?:^|; )' + key + '=([^;]*)')
                );
                if (cookieMatch && cookieMatch[1]) {
                    mergeToastMapFromRaw(pending, decodeURIComponent(cookieMatch[1]));
                }
            } catch (e) { /* ignore */ }
            return pending;
        }

        function writeStorageToastMap(key, map, maxAgeSeconds) {
            var hasEntries = map && Object.keys(map).length > 0;
            var payload = JSON.stringify(map || {});
            try {
                if (hasEntries) {
                    sessionStorage.setItem(key, payload);
                } else {
                    sessionStorage.removeItem(key);
                }
            } catch (e) { /* ignore */ }
            try {
                if (hasEntries) {
                    localStorage.setItem(key, payload);
                } else {
                    localStorage.removeItem(key);
                }
            } catch (e) { /* ignore */ }
            try {
                if (hasEntries) {
                    document.cookie = key + '=' + encodeURIComponent(payload) +
                        '; path=/; max-age=' + (maxAgeSeconds || 86400) + '; SameSite=Lax';
                } else {
                    document.cookie = key + '=; path=/; max-age=0; SameSite=Lax';
                }
            } catch (e) { /* ignore */ }
        }

        function readPendingNewVersionToastMap() {
            var pending = readStorageToastMap(DOCUMENT_NEW_VERSION_TOAST_PENDING_KEY);
            var shown = readStorageToastMap(DOCUMENT_NEW_VERSION_TOAST_SHOWN_KEY);
            var changed = false;
            Object.keys(pending).forEach(function (id) {
                if (shown[id]) {
                    delete pending[id];
                    changed = true;
                }
            });
            if (changed) {
                writeStorageToastMap(DOCUMENT_NEW_VERSION_TOAST_PENDING_KEY, pending, 86400);
            }
            return pending;
        }

        function clearConsumedNewVersionToastIds(contentIds) {
            if (!contentIds || !contentIds.length) {
                return;
            }
            var pending = readStorageToastMap(DOCUMENT_NEW_VERSION_TOAST_PENDING_KEY);
            var shown = readStorageToastMap(DOCUMENT_NEW_VERSION_TOAST_SHOWN_KEY);
            var pendingChanged = false;
            contentIds.forEach(function (contentId) {
                if (!contentId) {
                    return;
                }
                if (pending[contentId]) {
                    delete pending[contentId];
                    pendingChanged = true;
                }
                shown[contentId] = Date.now();
            });
            if (pendingChanged) {
                writeStorageToastMap(DOCUMENT_NEW_VERSION_TOAST_PENDING_KEY, pending, 86400);
            }
            writeStorageToastMap(DOCUMENT_NEW_VERSION_TOAST_SHOWN_KEY, shown, 604800);
        }

        function pushPendingNewVersionToastsToNgxFrame() {
            if ($state.current.name !== "storm.content-documents") {
                return;
            }
            var pending = readPendingNewVersionToastMap();
            if (!Object.keys(pending).length) {
                return;
            }
            var frame = document.getElementById('ngxFrame');
            if (!frame || !frame.contentWindow) {
                return;
            }
            try {
                frame.contentWindow.postMessage(
                    { documentNewVersionToastPending: pending },
                    getNgxHostUrl()
                );
            } catch (e) {
                // Ignore cross-window messaging errors.
            }
        }

        function schedulePendingNewVersionToastPush() {
            pendingToastPushTimeouts.forEach(function (timeoutId) {
                $timeout.cancel(timeoutId);
            });
            pendingToastPushTimeouts = [];
            [300, 1000, 2500].forEach(function (delayMs) {
                pendingToastPushTimeouts.push(
                    $timeout(pushPendingNewVersionToastsToNgxFrame, delayMs)
                );
            });
        }

        function setNgxPageUrl() {
            var ngxUrl = null;
            var hostUrl = getNgxHostUrl();
            var path = $location.path();
            $rootScope.selectedLeftNavMenu = 'home';

            if ($state.current.name === "storm.content-documents") {
                $rootScope.selectedLeftNavMenu = 'library';
                const queryParams = JSON.parse(sessionStorage.getItem('DocumentListingQueryParams'));
                var query = []
                if(queryParams && queryParams.hasOwnProperty('page')) {
                    query.push('page='+queryParams.page)
                } 
                if (queryParams && queryParams.hasOwnProperty('size')) {
                    query.push('size='+queryParams.size)
                }
                if (queryParams && queryParams.hasOwnProperty('search')) {
                    query.push('search='+queryParams.search)
                } 
                sessionStorage.removeItem('DocumentListingQueryParams')
                ngxUrl = hostUrl + "/ngx/contents/content-documents?" + query.join('&');
            }
            if ($state.current.name === "storm.content-view") {
                var id = path.split("/").pop();
                ngxUrl = hostUrl + "/ngx/contents/" + id;
            }
            vm.ngxUrlTrusted = $sce.trustAsResourceUrl(ngxUrl);
            if ($state.current.name === "storm.content-documents") {
                schedulePendingNewVersionToastPush();
            }
        }

        function handleNgxEvent(event) {
            var hostUrl = getNgxHostUrl();
            if (event.origin !== hostUrl) return;
            if (event.data && event.data.requestDocumentNewVersionToastPending) {
                pushPendingNewVersionToastsToNgxFrame();
                return;
            }
            if (event.data && event.data.consumedDocumentNewVersionToastIds) {
                clearConsumedNewVersionToastIds(event.data.consumedDocumentNewVersionToastIds);
                return;
            }
            if (event.data.ngxLocationChanged) {
                var ngState = event.data.ngxLocationChanged.ngState;
                var id = event.data.ngxLocationChanged.id;
                vm.isIFrameDataLoaded = true;
                scopeApply();

                if(ngState === "storm.content-view")
                    return;

                if (id == null) {
                    $state.transitionTo(ngState, null, {
                        location: true,
                        inherit: true,
                        relative: $state.$current,
                        notify: false,
                    });
                } else {
                    $state.transitionTo(
                        ngState,
                        {
                            id: id,
                        },
                        {
                            location: true,
                            inherit: true,
                            relative: $state.$current,
                            notify: false,
                        }
                    );
                }
            }
            else if(event.data.navigate) {
                var ngState = event.data.navigate.toState;
                var stateParams = event.data.navigate.params || {};
                sessionStorage.setItem('DocumentListingQueryParams', JSON.stringify(stateParams));
                var routeParams = {
                    contentType: stateParams.contentType || 'document'
                };
                if (stateParams.id) {
                    routeParams.id = stateParams.id;
                }
                if (stateParams.copy) {
                    routeParams.copy = true;
                }
                if (stateParams.uploadNewVersion) {
                    routeParams.uploadNewVersion = true;
                }
                $state.go(ngState, routeParams);
            }
        }

        var scopeApply = function (fn) {
            var phase = $scope.$root.$$phase;
            if (phase !== "$apply" && phase !== "$digest") {
                return $scope.$apply(fn);
            }
        };

        $window.addEventListener("message", handleNgxEvent, false);

        // Unregister
        $scope.$on("$destroy", function () {
            window.removeEventListener("message", handleNgxEvent, false);
            pendingToastPushTimeouts.forEach(function (timeoutId) {
                $timeout.cancel(timeoutId);
            });
            pendingToastPushTimeouts = [];
        });
        setNgxPageUrl();
    }
})();
